import React from 'react';
import { Formik, Form } from 'formik';
import Grid from '@material-ui/core/Grid/Grid';
import { validationSchemaForStep1 } from './NetworkRegisterSchema/NetworkRegisterSchema';
import { RegisterFirmFormStep1Props } from './NetworkRegisterInterface/NetworkRegisterInterface';
import NetworkDetails from './NetworkDetailsForm';
import NetworkCommissionTerms from './NetworkComissionTermsForm';
import Button from '../../shared/Button/Button';

import './_NetworkRegisterForm.scss';

const RegisterFirmFormStep1: React.FC<RegisterFirmFormStep1Props> = ({
  handleSubmit,
  formData,
  commisionTerms,
  submissionRoutes,
  goBack,
}) => {
  return (
    <Formik initialValues={formData} onSubmit={handleSubmit} validationSchema={validationSchemaForStep1}>
      {({ setFieldValue }) => {
        return (
          <Form className="form network-register__form">
            <Grid container>
              <Grid item xs={6}>
                <NetworkDetails setFieldValue={setFieldValue} />
              </Grid>
              <Grid item xs={6}>
                <NetworkCommissionTerms commisionTerms={commisionTerms} submissionRoutesOptions={submissionRoutes} />
              </Grid>
            </Grid>
            <div className="form__navigation space-between">
              <div className="form__navigation-item">
                <Button className="form__back" type="button" label="Back" onClick={goBack} />
              </div>
              <div className="form__navigation-item">
                <Button className="form__submit" type="submit" label="Next" />
              </div>
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};

export default RegisterFirmFormStep1;
